import React from 'react';
import values from '../../data/values';
import Card from '../Card';
import { useTranslation } from 'react-i18next';

const ValueCards = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col lg:flex-row max-w-[1600px] mx-auto w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {values.map((value, index) => (
          <Card
            key={index}
            title={t(`values.values_list.list_item_${index}.title`)}
            description={t(`values.values_list.list_item_${index}.description`)}
          />
        ))}
      </div>
    </div>
  );
};

export default ValueCards;